import { render } from "./DashboardTwo.vue?vue&type=template&id=16f58bbc&scoped=true&ts=true"
import script from "./DashboardTwo.vue?vue&type=script&lang=ts"
export * from "./DashboardTwo.vue?vue&type=script&lang=ts"

import "./DashboardTwo.vue?vue&type=style&index=0&id=16f58bbc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f58bbc"]])

export default __exports__